import React from 'react';
import iconTrash from '../../assets/trash.svg';
import { formatEUR } from './constants';

// ─── OrderSummary ─────────────────────────────────────────────────────────────
// isEditable=true  → étape 1 : contrôles qty + suppression remises
// isEditable=false → étapes 2-4 : lecture seule
//
// Remises par article   → sous chaque article, gris, avec flèche
// Remises globales      → section séparée (tiret) en bas de la liste

const OrderSummary = ({
    items,
    totals,
    globalDiscounts = [],
    isEditable = false,
    canRemoveDiscounts = false,  // afficher les boutons de suppression de remises
    onUpdateQty,
    onRemoveItemDiscount,
    onRemoveGlobalDiscount,
}) => (
    <div className="dark-card order-summary flex-col">
        <h3 className="panel-title">COMMANDE</h3>

        <div className="order-items-list card">

            {/* ── Articles ── */}
            {items.map(item => (
                <div key={item.id} className="order-item-container">
                    <div className="order-item-main">
                        {isEditable ? (
                            <div className="item-actions">
                                {item.qty <= 1 ? (
                                    <button
                                        onClick={() => onUpdateQty(item.id, -1)}
                                        className="icon-btn"
                                        title="Supprimer"
                                    >
                                        <img src={iconTrash} alt="Supprimer" className="white_svg size-16" />
                                    </button>
                                ) : (
                                    <button
                                        onClick={() => onUpdateQty(item.id, -1)}
                                        className="qty-btn"
                                    >
                                        &minus;
                                    </button>
                                )}
                                <span className="qty-value">{item.qty}</span>
                                <button
                                    onClick={() => onUpdateQty(item.id, 1)}
                                    className="qty-btn"
                                >
                                    &#43;
                                </button>
                            </div>
                        ) : (
                            <span className="readonly-qty">{item.qty}</span>
                        )}
                        <span className="item-name">{item.name}</span>
                        <span className="item-price">{formatEUR(item.price * item.qty)}</span>
                    </div>

                    {/* Remises par article */}
                    {item.discounts?.length > 0 && (
                        <div className="item-discounts">
                            {item.discounts.map(d => (
                                <div key={d.id} className="discount-subline">
                                    <span className="discount-label">→ Remise ({d.label})</span>
                                    <span className="discount-amount">− {formatEUR(d.amount)}</span>
                                    {(isEditable || canRemoveDiscounts) && (
                                        <button
                                            onClick={() => onRemoveItemDiscount(item.id, d.id)}
                                            className="remove-discount-btn"
                                        >
                                            &times;
                                        </button>
                                    )}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            ))}

            {/* ── Remises globales — section séparée ── */}
            {globalDiscounts.length > 0 && (
                <div className="global-discounts-section">
                    {globalDiscounts.map(d => {
                        // Recalculer l'affichage du montant depuis la formule
                        const subtotal = items.reduce((s, i) => s + i.price * i.qty, 0);
                        const displayAmount = d.type === '%'
                            ? Math.round(subtotal * d.value / 100 * 100) / 100
                            : d.value;

                        return (
                            <div key={d.id} className="discount-subline global-discount-line">
                                <span className="discount-label">→ Remise ticket ({d.label})</span>
                                <span className="discount-amount">− {formatEUR(displayAmount)}</span>
                                {(isEditable || canRemoveDiscounts) && (
                                    <button
                                        onClick={() => onRemoveGlobalDiscount(d.id)}
                                        className="remove-discount-btn"
                                    >
                                        &times;
                                    </button>
                                )}
                            </div>
                        );
                    })}
                </div>
            )}
        </div>

        {/* ── Totaux ── */}
        <div className="order-totals">
            <div className="total-line text-muted">
                <span>Promotions</span>
                <span>
                    {totals.totalPromos > 0
                        ? `− ${formatEUR(totals.totalPromos)}`
                        : formatEUR(0)}
                </span>
            </div>
            <div className="total-line main-total">
                <span>Total TTC</span>
                <span>{formatEUR(totals.totalTTC)}</span>
            </div>
        </div>
    </div>
);

export default OrderSummary;